export const onOpenIntercomWidget = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  window.Intercom && window.Intercom('show')
}
